<template>
  <section class="cards-section" :class="isExpanded">
    <div class="cards-section__header">
      <span v-if="collapse" class="cards-section__icon">
        <AppIcon :icon="icon" />
      </span>
      <AppHeading @click="collapse && toggleTransitionCollapse()" :class="pointerClass" tag="h2">
        <span v-if="title" class="cards-section__title">{{ title }}</span>
      </AppHeading>
      <AppCounter :total="itemsLength" />
    </div>
    <TransitionCollapse :time="transitionDuration">
      <!-- section body -->
      <template v-if="(visible && itemsLength) || (visible && isAccountDashboard)">
        <slot />
      </template>
    </TransitionCollapse>
  </section>
</template>

<script>
// Utitlities
import TransitionCollapse from 'Mixins/TransitionCollapse'
// Components
import AppIcon from 'Ui/AppIcon'
import AppCounter from 'Ui/AppCounter'
import AppHeading from 'Ui/AppHeading'

export default {
  name: 'CardsSection',

  components: {
    AppIcon,
    AppHeading,
    AppCounter,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    itemsLength: {
      type: Number,
      default: 0,
    },

    collapse: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [TransitionCollapse],

  methods: {
    // Replacing the transition collapse pre-setted function
    toggleTransitionCollapse() {
      if (this.transitioning || !this.itemsLength) return
      this.transitioning = true
      this.visible = !this.visible
      setTimeout(() => {
        this.transitioning = false
      }, this.transitionDuration + 50)
    },
  },

  computed: {
    icon() {
      return this.visible && this.itemsLength ? 'far fa-minus' : 'far fa-plus'
    },

    isExpanded() {
      return this.visible && this.itemsLength ? 'expanded' : ''
    },

    isAccountDashboard() {
      return this.$route.matched.some((route) => route.path.includes('account'))
    },

    pointerClass() {
      return this.collapse && this.itemsLength && 'pointer'
    },
  },
}
</script>

<style scoped>
.cards-section {
  margin: 60px 0;
}

.cards-section:first-of-type {
  margin-top: 0;
}

.cards-section__header {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  width: 100%;
  text-align: left;
  border-radius: 4px;
  outline: none;
  user-select: none;
}

.cards-section__title {
  font-size: 1.75rem;
  line-height: 2rem;
  font-weight: 900;
  color: var(--c-primary);
}

.cards-section__title.pointer {
  cursor: pointer;
}

.cards-section__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background: var(--c-secondary-400);
  border-radius: 6px;
  backface-visibility: hidden;
}
</style>
